import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import Link from '@base/lib/ThemeLink';
import { RouteEnum } from 'pro/config/routers';
import Iconfont from '@base/lib/Iconfont';
import HeaderLogo from '@app/common/PageHeader/HeaderLogo';
import { useTrans } from 'base/utils/i18n';

const CheckoutHeader: React.FC = () => {
    const { t } = useTrans();
    return (
        <div className={styles.header}>
            <div className="wrapper flex flex-middle">
                <HeaderLogo/>

                <div className={styles.secure}>
                    <Iconfont className={cn(
                        styles.icon,
                        'icon-lock'
                    )}/>
                    <span>{t('web_checkout_secure_checkout')}</span>
                </div>

                <div className="flex-1 text-right">
                    <Link href={RouteEnum.SHOP}>
                        <a className={styles.shopping}>
                            {t('web_common_continue_shopping')}
                        </a>
                    </Link>
                </div>
            </div>
        </div>
    )
};

export default CheckoutHeader;
